<template>
  <v-icon v-if="showScrollDown" class="scroll-down" color="error" x-large>mdi-chevron-down</v-icon>
</template>

<script>
export default {
  name:"ScrollDownIcon",
  data() {
    return {
      showScrollDown: false,
    };
  },
  mounted() {
    window.addEventListener("scroll", this.handleScroll);
  },
  methods: {
    handleScroll() {
      this.showScrollDown = window.scrollY + window.innerHeight < document.body.offsetHeight;
    },
  },
};
</script>

<style scoped>
.scroll-down {
  position: fixed;
  bottom: 2rem;
  right: 2rem;
  animation: bounce 2s infinite;
  color:red
}
@keyframes bounce {
  0%, 20%, 50%, 80%, 100% {
    transform: translateY(0);
  }
  40% {
    transform:translateY(-30px);
  }
  60% {
    transform: translateY(-15px);
  }
}

</style>